export function replaceEspacosPorHTML(texto) {
   if(texto !== null){
      return texto.replace(/\n/g, '<br>');
   }else{
      return texto
   }
   
}